module.exports = __webpack_public_path__ + "img/EAST_YEARBOOK-5-min.5b84bee7.jpg";